import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import { Phrase } from '@yi/core';
import { i18n_get_started } from '@yi/i18n/phrases/i18n_get_started';

import { useAccessTier } from '~/src/common/subscription';
import { MEMBERSHIP_PATHNAME } from '~/src/common/routes';
import { useConvertedContentFrom } from '~/src/common/sign-up/converted-content-from';
import { navigate } from '~/src/common/utilities/utilities';
import { Button } from '~/src/components/buttons/Button';
import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints, darkGrey, fontWeight } from '~/styles';

const Heading = styled.h1`
  font-size: 20px;
  font-weight: ${fontWeight.semiBold};
  letter-spacing: 1px;
  color: ${darkGrey};
`;

const Container = styled.div<{ centeredDesktop: boolean }>`
  font-size: 20px;
  font-weight: ${fontWeight.semiBold};
  letter-spacing: 1px;
  color: ${darkGrey};

  ${({ centeredDesktop }) => {
    if (centeredDesktop) {
      return `
        ${breakpoints.minTabletLandscape} {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      `;
    }
    return '';
  }}
`;

interface Props {
  headingText: string | Phrase;
  headingStyle?: React.CSSProperties;
  buttonText?: string | Phrase;
  centeredDesktop?: boolean;
}

const marginBottom = '20px';

export const MembershipCTA: React.FC<Props> = ({
  headingText,
  headingStyle = {},
  buttonText = i18n_get_started,
  centeredDesktop = false,
}) => {
  const { loading, hasMembershipAccess } = useAccessTier();
  const { locale } = useLocale();
  const { addToUrlConvertedContentFrom } = useConvertedContentFrom();

  const url = addToUrlConvertedContentFrom({ targetUrl: MEMBERSHIP_PATHNAME });

  const onClick = useCallback(() => {
    navigate(url);
  }, [url]);
  if (loading || hasMembershipAccess) return null;

  return (
    <Container centeredDesktop={centeredDesktop} style={{ marginBottom }}>
      <Heading style={{ marginBottom, ...headingStyle }}>
        {typeof headingText === 'function' ? headingText(locale) : headingText}
      </Heading>
      <Button onClick={onClick}>
        {typeof buttonText === 'function' ? buttonText(locale) : buttonText}
      </Button>
    </Container>
  );
};
